import React from 'react';
import FadeInImage from 'components/FadeInImage';
import { useSelector } from 'react-redux';
import './style.scss';

export const ProfileImagePreview = () => {
  const { configProfileForm } = useSelector(state => state.profilesManager);

  return (
    <div className="profile-image-preview">
      {configProfileForm?.firstname && (
        <span className="profile-image-preview__name">
          {configProfileForm.firstname}
        </span>
      )}
      <FadeInImage
        imageAlt="cv-profile"
        imageSrc={configProfileForm?.user_image}
        width={88}
        height={88}
        classNames={['profile-image-preview__img']}
      />
    </div>
  );
};
